import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-male-chair-workouts': {
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-workouts&exp=web_chair_workouts_male_scratch_card~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_chair_workouts_male_scratch_card'
					),
			},
		},
	},
]

export default config
